export function getCurrencySymbolFromPhone(phone) {
  const p = String(phone || "").replace(/\s|-/g, "");

  // If no +, fallback
  if (!p.startsWith("+")) return " ";

  // Country calling code mapping (basic set)
  const map = [
    { code: "+94", symbol: "LKR" }, // Sri Lanka
    { code: "+91", symbol: "₹" },   // India
    { code: "+44", symbol: "£" },   // UK
    { code: "+33", symbol: "€" },   // France
    { code: "+49", symbol: "€" },   // Germany
    { code: "+39", symbol: "€" },   // Italy
    { code: "+34", symbol: "€" },   // Spain
    { code: "+31", symbol: "€" },   // Netherlands
    { code: "+351", symbol: "€" },  // Portugal
    { code: "+1", symbol: "$" },    // USA/Canada
    { code: "+61", symbol: "$" },   // Australia
    { code: "+971", symbol: "د.إ" }, // UAE
    { code: "+966", symbol: "﷼" },   // Saudi
  ];

  // longest prefix match (important: +351 before +3 etc)
  map.sort((a, b) => b.code.length - a.code.length);

  const hit = map.find((x) => p.startsWith(x.code));
  return hit ? hit.symbol : " ";
}
